<template>
  <div id="sidebar-menu">
    <div class="vertical-menu">
      <simplebar :settings="settings" class="h-100" ref="currentMenu" id="my-element">
          <div id="sidebar-menu">
            <ul id="side-menu" class="metismenu list-unstyled">
              <li class="font-weight-bold sidebar-heading">Danh mục</li>

              <template v-for="item in menuItems">
                <li class="menu-title" v-if="item.isTitle" :key="item.id">
                  {{ item.label }}
                </li>
                <li v-if="!item.isTitle && !item.isLayout" :key="item.id">
<!-----------------------------------------ITEM CÓ SUB ITEM------------------------------------------------>
                  <router-link :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
                    :to="checkActive(item)" 
                    v-if="hasItems(item) && checkChild(item)" class="is-parent">
                    <i :class="`fz-16 ${item.icon}`" />
                    <span>{{ item.label }}</span>
                    <span :class="`badge badge-pill badge-${item.badge.variant} float-right`" v-if="item.badge">
                      {{ item.badge.text }}
                    </span>
                  </router-link>
<!-----------------------------------------ITEM KHÔNG CÓ SUB ITEM-------------------------------------------->
                  <router-link :to="item.link" v-if="!hasItems(item) && item.link" class="side-nav-link-ref"
                  v-show="dataPermission.includes(item.listPermission[0])">
                    <i :class="`fz-16 ${item.icon}`" v-if="item.icon"/>
                    <span>
                      {{ item.label }}
                    </span>
                    <span :class="`badge badge-pill badge-${item.badge.variant} float-right`" v-if="item.badge">
                      {{ item.badge.text }}
                    </span>
                  </router-link>
<!---------------------------------ITEM TRỎ LINK SANG WEB KHÁC (NEXTLEND,...)---------------------------------->
                  <a v-if="!hasItems(item) && item.href" target="_blank" :href="item.href" class="side-nav-link-ref">
                    <i :class="`fz-16 ${item.icon}`" v-if="item.icon"/>
                    <span>{{ item.label }}</span>
                  </a>
                  <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
                    <li v-for="(subitem, index) of item.subItems" :key="index">
                      <a v-if="subitem.href && !hasItems(subitem)" :href="subitem.href" class="side-nav-link-ref">
                        {{ subitem.label }}
                      </a>
<!------------------------------------SUB ITEM CỦA ITEM CÓ SUB ITEM--------------------------------------------->
                      <router-link
                        v-else-if="!hasItems(subitem)"
                        v-show="dataPermission.includes(subitem.permission)"
                        :to="subitem.link"
                        class="side-nav-link-ref">
                        {{ subitem.label }}
                      </router-link>
<!------------------------->
                      <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">
                        {{ subitem.label }}
                      </a>

                      <ul
                        v-if="hasItems(subitem)"
                        class="sub-menu mm-collapse"
                        aria-expanded="false">
                        <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                          <a
                            v-if="subSubitem.href"
                            :href="subSubitem.href"
                            class="side-nav-link-ref"
                          >
                            {{ subSubitem.label }}
                          </a>

                          <router-link v-else :to="subSubitem.link" class="side-nav-link-ref">
                            {{ subSubitem.label}}
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </div>
      </simplebar>
    </div>
  </div>
</template>
<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import simplebar from 'simplebar-vue'

import { menuItems } from "./menu";
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      menuItems: [],
      menuData: null,
      settings: {
        minScrollbarLength: 60
      },
      indexActive: '',
      dataPermission: JSON.parse(localStorage.getItem('dataPermission')),
    };
  },

  components: { simplebar },

  created() {
    this.menuItems = this.getMenuSideBar
  },

  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i].pathname);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },

  methods: {
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    
    checkActive(item) {
      const childPer = []
      item.listPermission.map((e) => {
        const check = this.dataPermission.includes(e)
        if (check) {
          childPer.push(e)
        }
      })
      const indexChild = item.subItems.findIndex(e => e.permission === childPer[0])
      if (indexChild != -1) {
        return item.subItems[indexChild].link
      }
    },

    checkChild (child) {
      if (this.dataPermission && child.listPermission) {
        const childPer = []
        child.listPermission.map((item) => {
          const check = this.dataPermission.includes(item)
          if (check) {
            childPer.push(item)
          }
        })

        if (childPer.length === 0) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
  },

  computed: {
      ...mapGetters("sidebar", ["getMenuSideBar"])
  },
};
</script>

